export default class Contributor {
  id?: number;
  name!: string;
  lastname!: string;
  email!: string;
  createdAt?: Date;
  updatedAt?: Date;
}
